import Alert from 'components/common/alert/Alert';

export default Alert;
